import styles from './ModalList.module.scss';

const Fallback = () => {
  return (
    <div className={styles.fallback}>
      <span className="spinner" />
    </div>
  );
};

export default Fallback;
